import { PORTAL_TOOL_NAVIGATE_EVENT } from '@terra/shared-dto-chat-types';
import { useProxyStore } from '../../../../store/proxy-store';
import { navigateToApplicationSettingsSubTab } from '../../../../utils/navigateToApplicationSettingsSubTab';

export function openMcpConnectionSettings({
  applicationId,
  identityId,
  oauthOnly = false,
}: {
  applicationId: string;
  identityId?: string;
  oauthOnly?: boolean;
}): void {
  useProxyStore.getState().setMcpConnectionEditRequest({
    applicationId,
    identityId,
    openEdit: true,
    oauthOnly,
  });

  navigateToApplicationSettingsSubTab('mcp-connection');

  window.dispatchEvent(
    new CustomEvent(PORTAL_TOOL_NAVIGATE_EVENT, {
      detail: {
        tabType: 'settings-mcp-connection',
        openEdit: true,
        identityId,
      },
    }),
  );
}
